import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { CertificateComponent } from '../../sprinklers/certificate-sprinklers/certificate.component';

@Component({
  selector: 'authority-labs-certificate-aerosol-shutdown',
  templateUrl: './certificate-aerosol-shutdown.component.html',
  styleUrls: ['./certificate-aerosol-shutdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateAerosolShutdownComponent extends CertificateComponent {}
